<template>
  <div>
    <div class="category"  :class="{'border': isModal}">
      <span class="trainMenu-all" @click = 'updateCategoryPath(categoryPath.slice(0, 1), -1)' :style = 'catStyle(categoryPath[0])'>{{categoryPath[0].title}} </span>
      <span class="trainMenu-category" v-for = '(cat,index) of branchCategories' :key="index" :style = 'catStyle(cat)' @click = 'updateCategoryPath([cat], 0)'>
      {{cat.title}}
      </span>
    </div>
    <div class="oneGrade-wrap" :class="{'border': isModal }">
      <span class="oneGrade-item"  v-for = '(cat,index) of leafCategories' :key="index" :style = 'catStyle(cat)' @click = 'updateCategoryPath([cat.parentCategory, cat], 0)'>
      {{cat.title}}
      </span>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import NestMenuItem from '../../foundation/ui/controls/nest-menu-item';
  export default ({
    components: {
      NestMenuItem,
    },
    data() {
      return{
        address: GLOBAL,
        //分类路径
        categoryPath: [],
        activeCat: null,
      }
    },
    props:['trainCategories','isModal'],
    computed: {
      branchCategories: {
        get(){
          if(undefined != this.categoryPath[0]){
            return this.categoryPath[0].subCategories;
          }
          return [];
        }
        // this.categoryPath = this.categoryPath.slice(0, index + 1).concat(categories);
        // this.$emit('category-path-updated', this.categoryPath);
      },
      leafCategories: {
        get(){
          if (undefined != this.categoryPath[1]){
            return this.categoryPath[1].leafs;
          }
          return this.categoryPath[0].leafs;
        }
      },
    },
    mounted(){
      this.updateCategoryPath([this.trainCategories.rootCategory]);
    },
    methods : {
      updateCategoryPath(categories, index){
        if (undefined === index){
          index = this.categoryPath.indexOf(this.activeCat);
        }
        this.categoryPath = this.categoryPath.slice(0, index + 1).concat(categories);
        this.$emit('category-path-updated', this.categoryPath);
      },
      catStyle: function(cat){
        if (-1 !== this.categoryPath.map(x=>x.title).indexOf(cat.title)){
          return {
            fontWeight: 700,
            color:'#333'
          };
        }
      }
    }
  })
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
  .mu-tab-line
    background-color #0a81e5 !important
  .mu-tabs
    background-color #fff
  .tab-font
    color #999 !important
  .first-t
    color #000
  .first-t:hover
    color #999
    border-bottom 2px solid #2196f3
  .active-first-t
    color #999
    border-bottom 2px solid #2196f3
  .second-t
    color #999
  .second-t:hover
    color #000
    border-bottom 2px solid #2196f3
  .active-second-t
    color #000
    border-bottom 2px solid #2196f3
  .trainMenu-all
    display inline-block
    height 60px
    line-height 60px
    cursor pointer
    color #999
  .trainMenu-category
    display inline-block
    height 60px
    line-height 60px
    margin-left 40px
    cursor pointer
    color #999
  .oneGrade-wrap
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    min-height: 60px;
    padding: 0 10px 0 30px;
  .oneGrade-item
    margin-right 36px
    font-size 14px
    cursor pointer
    line-height 30px
    color #999
  .border
    border-bottom 1px solid #eee
    margin-left 0px !important
    .trainMenu-all
      margin-left 40px
    .oneGrade-item
      margin-left 10px
  .category
    margin-left 30px
    font-size 14px
</style>



// WEBPACK FOOTER //
// trainMenu.vue?2acf6a76